
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/best-instagram-apps",
      function () {
        return require("private-next-pages/articles/best-instagram-apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/best-instagram-apps"])
      });
    }
  